/// <amd-module name="SearchUI/Components/Callout/Callout.Props" />
export interface ICalloutComponentProps {
    targetElement: HTMLElement | null;

    title: string;

    content: string;

    id: string;
}